import { useTranslation } from "react-i18next";
import { AlertTriangle, CheckCircle2 } from "lucide-react";

// شروط وأحكام (5 بنود) + checkbox للموافقة الشاملة.
export const MyBillSignTerms = ({ terms, setTerms }) => {
  const { t } = useTranslation();
  const items = [
    t("acct.bills.mysign.t1"),
    t("acct.bills.mysign.t2"),
    t("acct.bills.mysign.t3"),
    t("acct.bills.mysign.t4"),
    t("acct.bills.mysign.t5"),
  ];
  return (
    <>
      <div className="rounded-2xl border-2 border-amber-300 bg-amber-50 p-4">
        <p className="mb-3 flex items-center gap-2 text-sm font-black text-amber-800">
          <AlertTriangle className="h-4 w-4" /> {t("acct.bills.mysign.termsTitle")}
        </p>
        <ol className="space-y-2 text-xs font-bold text-amber-900">
          {items.map((txt, i) => (
            <li key={i} className="flex items-start gap-2">
              <span className="mt-0.5 grid h-5 w-5 shrink-0 place-content-center rounded-full bg-amber-500 text-[10px] font-black text-white">{i + 1}</span>
              <span className="flex-1">{txt}</span>
            </li>
          ))}
        </ol>
      </div>
      <label className="flex cursor-pointer items-start gap-3 rounded-2xl border border-slate-200 bg-white p-3"
             data-testid="my-terms-label">
        <input type="checkbox" checked={terms} onChange={(e) => setTerms(e.target.checked)}
               data-testid="my-terms-check" className="mt-0.5 h-4 w-4 accent-emerald-600" />
        <span className="flex-1 text-xs font-bold text-slate-800">
          <CheckCircle2 className="mb-1 me-1 inline h-4 w-4 text-emerald-600" />
          {t("acct.bills.mysign.agreeTerms")}
        </span>
      </label>
    </>
  );
};
